'use strict';

var FirebaseIndirectArray = require('./FirebaseIndirectArray');
var KayleeBase = require('./KayleeBase');
var KayleeCache = require('./KayleeCache');
var KayleeLog = require('./KayleeLog');
var KayleeUtil = require('./KayleeUtil');
//var log = require('../log/Log').channel('KayleeLogs');

var KayleeLogs = {
    fromJson: fromJson,
    getLogsForController: getLogsForController,
};

function fromJson(data) {
    var reqProps = [ '$controllerCacheKey' ];
    return FirebaseIndirectArray.$fromJson(data, 'Logs', reqProps, reqProps,
        function(data) {
            var controller = KayleeCache.get(data.$controllerCacheKey);
            return getLogsForController(controller, data.$limit);
        }
    );
}

// Returns a promise that resolves to a Logs object that contains the logs
// for the specified controller.

function getLogsForController(controller, limit) {
    var key = 'Logs for Controller ' + controller.$id;
    var logs = KayleeCache.get(key);

    if (logs === null) {
        logs = new Logs(controller, limit);
        KayleeCache.put(key, logs);
    }

    return logs;
}

function Logs(controller, limit) {
    var self = this;
    var srcRef = KayleeBase.app.database()
        .ref('index/logsByController/' + controller.$id);

    if (typeof limit !== 'undefined') {
        srcRef = srcRef.orderByKey().limitToLast(limit);
    }

    FirebaseIndirectArray.call(self, srcRef, KayleeLog.getLog);
    self.$nodeType = 'logs';
    self.$controller = controller;
    self.$limit = limit;

    KayleeUtil.bindPrototypeMethods(Logs.prototype, self, self.$items);
    this.$items.$self = this;
    return self.$items;
}

Logs.prototype = Object.create(FirebaseIndirectArray.prototype);
Logs.prototype.constructor = Logs;

Logs.prototype.$toJson = function() {
    return FirebaseIndirectArray.prototype.$toJson.call(this,
        [ '$limit' ], { $controllerCacheKey: this.$controller.$cacheKey });
};

Logs.prototype.toString = function() {
    return '[Logs for ' + this.$controller + ']';
};

module.exports = KayleeLogs;
